import React from 'react';
import { Main } from './components';

// 🎯 Entrada principal del módulo de Packing Masivo
// Mantiene la misma firma que otros módulos (Packing, Picking, etc.)
export const MassivePacking: React.FC = () => {
  return <Main />;
};

